<template>
  <div class="pt-5">
    <SimpleSectionHeader
      class="tw-pt-[170px]"
      :wellFormatted="true"
      title="Ressources"
      :isSectionTitle="true"
    >
      <div class="container">
        <input
          type="text"
          class="tw-p-4 tw-w-full hover:tw-shadow-lg tw-duration-500"
          placeholder="Recherche ...."
        />
      </div>
    </SimpleSectionHeader>

    <div class="container" v-if="!targetItem?.id">
      <div class="row">
        <div class="col-md-4 mb-4" v-for="doc in allDocs" :key="doc.id">
          <div
            class="card hover:tw-shadow-lg tw-duration-500 px-4 py-3 border-0 tw-rounded-none tw-flex tw-items-center gap-2"
          >
            <div class="icon">
              <vue-feather type="file-text" class="tw-w-10"></vue-feather>
            </div>
            <div class="tw-text-lg tw-text-slate-500">{{ doc.label }}</div>
            <div>
              <button class="btn btn-primary py-2" @click="selectDoc(doc)">
                Consulter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Single item -->
    <div class="container" v-else>
      <div class="row">
        <div class="col-md-4">
          <CardWithLineGeneric class="tw-border">
            <template #title>
              <div>Informations du document</div>
              <div class="tw-absolute tw-right-4 tw-top-6">
                <button @click="targetItem = {}">
                  <vue-feather type="x" class="tw-w-6 tw-text-gray-400" />
                </button>
              </div>
            </template>
            <template #body>
              <div
                class="card-body text-center d-flex justify-content-center flex-column gap-2"
              >
                <div class="d-flex justify-content-center mt-4">
                  <div
                    class="tw-bg-orange-500 tw-p-6 tw-rounded-full text-white"
                  >
                    <vue-feather type="file-text" class="tw-w-10"></vue-feather>
                  </div>
                </div>
                <div class="tw-text-lg tw-text-slate-500 mt-4">
                  {{ targetItem.label }}
                </div>
                <div class="tw-text-slate-600">
                  Publié le : {{ targetItem.created_at }}
                </div>
              </div>
            </template>
          </CardWithLineGeneric>
        </div>
        <div class="col-md-8">
          <CardWithLineGeneric>
            <template #title>Visionnage</template>
            <template #body>
                <iframe :src="BACK_URL + '/dummy-file'" width="100%"  height="400"/>
            </template>
          </CardWithLineGeneric>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import SimpleSectionHeader from "../generics/Headers/SimpleSectionHeader/SimpleSectionHeader.vue";
import CardWithLineGeneric from "../generics/Cards/CardWithLine/CardWithLineGeneric.vue";
import { BACK_URL } from "../../statics/app_static";

const allDocs = [
  { id: 1, label: "Aspect juridique", created_at: "2025-12-06" },
  { id: 2, label: "Contrat client", created_at: "2025-12-07" },
  { id: 3, label: "Facturation", created_at: "2025-12-08" },
  { id: 4, label: "Ressources humaines", created_at: "2025-12-09" },
  { id: 5, label: "Stratégie commerciale", created_at: "2025-12-10" },
  { id: 6, label: "Documentation technique", created_at: "2025-12-11" },
  { id: 7, label: "Politique interne", created_at: "2025-12-12" },
  { id: 8, label: "Plan de développement", created_at: "2025-12-13" },
  { id: 9, label: "Rapport annuel", created_at: "2025-12-14" },
  { id: 10, label: "Audit financier", created_at: "2025-12-15" },
  { id: 11, label: "Guide utilisateur", created_at: "2025-12-16" },
  { id: 12, label: "Manuel technique", created_at: "2025-12-17" },
  { id: 13, label: "Analyse de marché", created_at: "2025-12-18" },
  { id: 14, label: "Cahier des charges", created_at: "2025-12-19" },
  { id: 15, label: "Plan marketing", created_at: "2025-12-20" },
  { id: 16, label: "Étude concurrentielle", created_at: "2025-12-21" },
  { id: 17, label: "Processus interne", created_at: "2025-12-22" },
  { id: 18, label: "Feuille de route", created_at: "2025-12-23" },
  { id: 19, label: "Reporting mensuel", created_at: "2025-12-24" },
  { id: 20, label: "Compte-rendu réunion", created_at: "2025-12-25" },
];

const targetItem = ref({});

const selectDoc = (elt) => {
  targetItem.value = elt;
};

onMounted(() => {
  targetItem.value = allDocs[0];
});
</script>
